webpackJsonp([30],{

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(575),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['id'],
  data: function data() {
    return {
      loading: false,
      err: '',
      success: '',
      activateAfterCopy: true
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.loading = true;
      this.$http.post('catalog/copy/' + this.id, { activateAfterCopy: this.activateAfterCopy }).then(function (res) {
        if (res.body.status === 'Success') {
          _this.loading = false;
          _this.success = res.body.statusText;
          setTimeout(function () {
            _this.success = '';
            _this.$emit('close');
          }, 5000);
          return;
        }
        _this.err = res.body.statusText;
      }, function (err) {
        _this.loading = false;
        _this.err = err.body.statusText || err.body.message;
      });
    }
  }
});

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [_c('p', [_vm._v("Would you like to copy and push catalog to all companies in corporation?")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pb-4",
    attrs: {
      "label": _vm.$lang.labels.activateAfterCopy,
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.activateAfterCopy),
      callback: function($$v) {
        _vm.activateAfterCopy = $$v
      },
      expression: "activateAfterCopy"
    }
  }), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": "",
      "outline": "",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.no))]), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.yes))])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/30.4c921b06b41fa568697c.js